/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const RulesUnorderedList = styled("ul")({
    marginTop: 0,
    marginBottom: "1em",
});
